<template>
  <b-modal
    id="modalReport"
    title="Export PDF"
    size="xl"
    ok-only
  >
    <b-row>
      <b-col
        md="12"
        class="d-flex align-items-center justify-content-end mb-1"
      >
        <b-button
          id="toggle-btn"
          size="sm"
          variant="warning"
          @click="generatePDF()"
        > Download <feather-icon
          class="text-light"
          icon="ArrowDownIcon"
          size="18"
        />
        </b-button>
      </b-col>
    </b-row>
    <div id="Report">
      <b-row>
        <b-col>
          <b-img
            center
            :src="require('@/assets/images/logo/iconnew.png')"
            width="150"
            alt="Center image"
          />
          <div style="text-align: center; padding-top: 15px">
            <span style="font-size: 18px; font-weight:bold">
              โรงพยาบาลนครปฐม
            </span><br>
            <span style="font-size: 16px;">
              รายงาน แจ้งเตือนการขัดข้องของอุปกรณ์ในแต่ละองค์กร<br>
              ตั้งแต่วันที่ {{ date.dateFrom }} ถึง {{ date.dateTo }}
            </span><br>

          </div>
        </b-col>
      </b-row>
      <br>
      <div>
        <b-table
          style="font-size:18px"
          :fields="fields"
          :items="items"
          :fixed="fixed"
          :bordered="bordered"
        />
      </div>
    </div>
  </b-modal>
</template>
<script>
import {
  BTable, BButton, BRow, BCol, BImg,
} from 'bootstrap-vue'
import html2PDF from 'jspdf-html2canvas'
import axios from '@axios'

export default {
  components: {
    BTable,
    BButton,
    BRow,
    BCol,
    BImg,
  },
  data() {
    return {
      items: [],
      date: {
        dateFrom: '',
        dateTo: '',
      },
      fields: [
        {
          key: 'date_time', label: 'Date Time', sortable: true,
        },
        {
          key: 'system_name', label: 'System', sortable: true,
        },
        {
          key: 'devid', label: 'Devid', sortable: true,
        },
        {
          key: 'reason', label: 'Reason', sortable: true, class: 'text-left',
        },
        {
          key: 'building', label: 'Building', sortable: true,
        },
      ],
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  mounted() {
  },
  methods: {
    generatePDF() {
      const page = document.getElementById('Report')
      const date = new Date().toJSON().slice(0, 10).replace(/-/g, '-')
      html2PDF(page, {
        jsPDF: {
          format: 'a4',
        },
        backgroundColor: '#ffffff',
        margin: {
          top: 5,
          right: 5,
          bottom: 5,
          left: 5,
        },
        imageType: 'image/jpeg',
        output: `Report ${date}.pdf`,
      })
    },
    getHistory(date) {
      axios
        .post('/get_historyNPT', date)
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length
          this.date.dateFrom = date.dateFrom
          this.date.dateTo = date.dateTo
        })
    },
  },
}
</script>
<style scoped>
</style>
